import {ModalBody} from '@chakra-ui/react';

export default function ChakraModalBody({children, ...props}) {
    return <ModalBody {...props}>{children}</ModalBody>;
}
